var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dictionaries"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[(_vm.$route.fullPath.match('/dictionaries/standards'))?_c('router-view'):_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }